module.exports = __webpack_public_path__ + "static/media/screenshot_home.48826235.png";